import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Provider} from 'react-redux';

import GlobalRegistry from './global-registry';
import {store} from './store';

export class Queue {
  queue = [];
  addToQueue = (promise) => {
    this.queue.push(promise);
  };
  resetQueue = () => {
    this.queue = [];
  };

  resolveAll = () => {
    return Promise.all(this.queue);
  };
}

export class InnerProvider extends React.Component {
  static contextTypes = {
    queue: PropTypes.object,
    globalRegistry: PropTypes.object,
    logger: PropTypes.object,
  };

  render() {
    const {queue} = this.context;
    const {onResolve} = this.props;

    queue.resetQueue();
    if (typeof onResolve === 'function') {
      onResolve(queue.resolveAll);
    }
    const {children} = this.props;

    if (typeof children === 'function') {
      return children();
    }

    return children;
  }
}

InnerProvider.propTypes = {
  children: PropTypes.node,
  onResolve: PropTypes.func,
};

class StoreProvider extends Component {
  constructor(props, ctx) {
    super(props, ctx);
    const {store} = this.props;
    this.queue = new Queue();
    this.globalRegistry = new GlobalRegistry(store.getState().gsConfig || {});
  }

  static childContextTypes = {
    queue: PropTypes.object,
    globalRegistry: PropTypes.object,
    logger: PropTypes.object,
    store: PropTypes.object,
  };

  static defaultProps = {
    store,
  };

  getChildContext() {
    const {logger} = this.props;

    return {
      queue: this.queue,
      globalRegistry: this.globalRegistry,
      logger,
    };
  }

  render() {
    const {store, onResolve, children} = this.props;

    return (
      <Provider store={store}>
        <InnerProvider onResolve={onResolve}>{children}</InnerProvider>
      </Provider>
    );
  }
}
StoreProvider.propTypes = {
  children: PropTypes.node,
  store: PropTypes.object,
  onResolve: PropTypes.func,
  logger: PropTypes.object,
};

export default StoreProvider;

/* istanbul ignore next */
if (process.env.NODE_ENV === 'test') {
  exports.Queue = Queue;
}
